import React, { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import Box from "@material-ui/core/Box";
import axios from 'axios';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import MetaTags from 'react-meta-tags';

import cookieName from '../../helpers/cookiesDeclaration';
import GeneralStyles from '../../styles/GeneralStyles';
import CircularProgress from '@material-ui/core/CircularProgress';


const useGeneralStyles = GeneralStyles;

function Home(props) {
    const [cookies, setCookie] = useCookies([cookieName]);
    const classesG = useGeneralStyles();
    const user = cookies[cookieName];

    // const matchTablet = useMediaQuery('(max-width:790px)');
    const matchMobile = useMediaQuery('(max-width:600px)');

    const [loading, setLoading] = useState(false);
    const [home, setHome] = useState(null);
    // const match = useMediaQuery('(min-width:600px)');

    useEffect(() => {
        setLoading(true);
        axios
            .get(
                `${process.env.REACT_APP_GATEWAY_END_POINT}/home`)
            .then((response) => {
                setHome(response.data);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(true);
            });
    }, []);

    const openFullscreen = () => {
        var video = document.getElementById("video2");
        video.style.display = "block";

        if (video.requestFullscreen) {
            video.pause();
            video.currentTime = 0;
            video.play();
            video.requestFullscreen();
        } else if (video.webkitRequestFullscreen) { /* Safari */
            video.pause();
            video.currentTime = 0;
            video.play();
            video.webkitRequestFullscreen();
        } else if (video.msRequestFullscreen) { /* IE11 */
            video.pause();
            video.currentTime = 0;
            video.play();
            video.msRequestFullscreen();
        } else if (video.webkitEnterFullscreen) { /* Mobile */
            video.pause();
            video.currentTime = 0;
            video.play();
            video.webkitEnterFullscreen();
        }
    }

    useEffect(() => {
        if (home !== '' && home !== undefined && home !== null && loading !== true) {
            var video2 = document.getElementById("video2");

            document.addEventListener("fullscreenchange", function () {
                // console.log(document.fullscreenElement);
                if (document.fullscreenElement === null && video2 !== null && video2 !== undefined) {
                    video2.style.display = "none";
                    video2.pause();
                }
            }, false);
            document.addEventListener("mozfullscreenchange", function () {
                if (document.mozFullScreen === false && video2 !== null && video2 !== undefined) {
                    video2.style.display = "none";
                    video2.pause();
                }
            }, false);
            document.addEventListener("webkitfullscreenchange", function () {
                if (document.webkitIsFullScreen === false && video2 !== null && video2 !== undefined) {
                    video2.style.display = "none";
                    video2.pause();
                }
            }, false);

            document.addEventListener("webkitendfullscreense ", function () {
                if (video2 !== null && video2 !== undefined) {
                    video2.style.display = "none";
                    video2.pause();
                }
            }, false);

            video2.addEventListener('webkitendfullscreen', function () {
                if (video2 !== null && video2 !== undefined) {
                    video2.style.display = "none";
                    video2.pause();
                }
            }, false);
        }

    }, [home, loading])


    const redirectPage = (params) => {
        setCookie(cookieName, JSON.stringify(user), { path: '/' });

        const { history, location } = props;
        const { from } = location.state || {
            from: {
                pathname: params,
            },
        };
        history.push(from);
    };

    const replace = (param) => {
        var value = '';

        if (param !== '' && param !== null && param !== undefined) {
            value = param.replace(`${process.env.REACT_APP_GATEWAY_PATH_REPLACE}`, `${process.env.REACT_APP_GATEWAY_PATH_S3}`);
        }

        return value;
    }

    return (
        <React.Fragment>
            {loading && (
                <div className={classesG.divProgress}>
                    <CircularProgress size={68} className={classesG.progress} />
                </div>
            )}
            {!loading && (
                <React.Fragment>
                    {home === null || home === undefined ? '' : (
                        <React.Fragment>
                            <MetaTags>
                                <title>{home.Page_title}</title>
                                <meta name="description" content={home.Page_description} />
                            </MetaTags>
                            <div className={classesG.container}>
                                <section className={classesG.sectionHomeVideo}>
                                    <div className={classesG.videoBackground}>
                                        <video src={matchMobile && (home.Mobile_background_video !== null || home.Mobile_background_video !== '') ?
                                            replace(home.Mobile_background_video.url)
                                            :
                                            replace(home.Desktop_background_video.url)
                                        }
                                            autoPlay playsInline loop={true} muted id='video1'>
                                        </video>
                                        <div className={classesG.videoLayer}></div>
                                        <span onClick={openFullscreen}>CLICK TO WATCH</span>
                                        {/* <PlayCircleOutlineIcon id={'playButton'} onClick={openFullscreen} /> */}
                                    </div>
                                    <Box mt={matchMobile && (home.Mobile_background_video !== null || home.Mobile_background_video !== '') ? 82 : 73}></Box>
                                </section>


                                <video src={matchMobile && (home.Mobile_video !== null || home.Mobile_video !== '') ? replace(home.Mobile_video.url) : replace(home.Desktop_video.url)}
                                    playsInline id='video2' className={classesG.videoBackground_section} style={{ display: 'none' }}>
                                </video>

                                <section className={classesG.section}>
                                    <div className={classesG.homeSecondSectionContent}>
                                        <div className={classesG.homeSectionBox}>
                                            <div className={classesG.secondSectionText}>
                                                <p>{document.msRequestFullscreen}</p>
                                                <h2>{home.Section1_title}</h2>
                                                <h4>{home.Section1_subtitle}</h4>
                                                <div dangerouslySetInnerHTML={{ __html: home.Section1_text }} />
                                            </div>
                                            <div className={classesG.secondSectionImage}>
                                                <img
                                                    className={classesG.imageHome_op2}
                                                    src={replace(home.Section1_image.url)}
                                                    alt={home.Section1_image.name}
                                                />
                                            </div>
                                        </div>

                                    </div>
                                </section>

                                <section className={classesG.section}>
                                    <div className={classesG.thirdSectionBackground}></div>
                                    <div className={classesG.thirdSectionContent}>
                                        <div className={classesG.homeThirdSectionBox}>
                                            <div className={classesG.thirdSectionImage}>
                                                <img
                                                    className={classesG.imageHome_op2}
                                                    src={replace(home.Section2_image.url)}
                                                    alt={home.Section2_image.name}
                                                />
                                            </div>
                                            <div className={classesG.thirdSectionText}>
                                                <h2>{home.Section2_title}</h2>
                                                <div dangerouslySetInnerHTML={{ __html: home.Section2_text }} />
                                            </div>
                                        </div>

                                        <div className={classesG.homeThirdSectionBox_op2} style={{ marginTop: '32px' }}>
                                            <div className={classesG.thirdSectionText_op2}>
                                                <div>
                                                    <h2>Our Brands</h2>
                                                    <div className={classesG.thirdSectionBoxesBlack}>

                                                        {home.Our_brands.length === 0 || home.Our_brands.length === '' ? '' :
                                                            home.Our_brands.map((items, i) => (

                                                                <a key={i} href={items.Url} target="_blank" rel="noreferrer">
                                                                    <div>
                                                                        <img
                                                                            src={replace(items.White_image.url)}
                                                                            alt={items.Name}
                                                                        />
                                                                    </div>
                                                                </a>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={classesG.secondSectionImage_op2}>
                                                <img
                                                    className={classesG.imageHome_op2}
                                                    src={replace(home.Section3_image.url)}
                                                    alt={home.Section3_image.name}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </section>


                                <section className={classesG.section}>
                                    <div className={classesG.fourthSectionBackground}></div>
                                    <div className={classesG.fourthSectionContent}>
                                        <div className={classesG.homeFourthSectionBox}>
                                            <div className={classesG.fourthSectionImage} onClick={() => redirectPage('/aboutUs')}>
                                                <img
                                                    className={classesG.fourthSectionImages}
                                                    src={replace(home.Image_AboutUs.url)}
                                                    alt={home.Image_AboutUs.name}
                                                />
                                                <p className={classesG.fourthSectionOption}>About Us</p>
                                            </div>
                                            <div className={classesG.fourthSectionImage} onClick={() => redirectPage('/news')}>
                                                <img
                                                    className={classesG.fourthSectionImages}
                                                    src={replace(home.Image_News.url)}
                                                    alt={home.Image_News.name}
                                                />
                                                <p className={classesG.fourthSectionOption}>News</p>
                                            </div>
                                        </div>

                                        <div className={classesG.homeFourthSectionBox}>
                                            <div className={classesG.fourthSectionImage} onClick={() => redirectPage('/ourWork')}>
                                                <img
                                                    className={classesG.fourthSectionImages}
                                                    src={replace(home.Image_OurWork.url)}
                                                    alt={home.Image_OurWork.name}
                                                />
                                                <p className={classesG.fourthSectionOption}>Our Work</p>
                                            </div>
                                            <div className={classesG.fourthSectionImage} onClick={() => redirectPage('/contact')}>
                                                <img
                                                    className={classesG.fourthSectionImages}
                                                    src={replace(home.Image_Contact.url)}
                                                    alt={home.Image_Contact.name}
                                                />
                                                <p className={classesG.fourthSectionOption}>Contact</p>
                                            </div>
                                        </div>
                                    </div>
                                </section>

                            </div>
                        </React.Fragment>
                    )}
                </React.Fragment>
            )}
        </React.Fragment>
    );
}

export default (Home);